<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Security</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Permissions
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button class="btn btn-primary pull-left" @click="createItem()">
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Permissions
                    <span><i class="ic-settings-horizontal"></i></span>
                  </h2>
                  <p>Configure and manage user access permissions.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Position Title"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Type</th>
                  <th class="text-center">Services Used</th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>{{ humanize(item.type) }}</td>
                  <td class="text-center">
                    {{ countUsedPermission(item.services) }} /
                    {{ permissionCount }}
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        @change="changeStatus(item)"
                        :disabled="!isAllowToUpdate"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete && item.type !== 'SystemManaged'"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="policymodal">
      <div class="modal-dialog modal-sm">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Permission</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper">
              <div class="col-sm-12">
                <div class="modal-content-body mt-5">
                  <ul
                    class="nav nav-tabs nav-justified nav-tab-modal tabs-mini-form"
                  >
                    <li :class="[activeTab === 'general' ? 'active' : '']">
                      <a
                        href="#identity-policy-general"
                        data-toggle="tab"
                        @click="activeTab = 'general'"
                      >
                        <span class="required">General</span>
                      </a>
                    </li>
                    <li :class="[activeTab === 'service' ? 'active' : '']">
                      <a
                        href="#identity-policy-service"
                        data-toggle="tab"
                        @click="activeTab = 'service'"
                      >
                        <span class="required">Service</span>
                      </a>
                    </li>
                  </ul>
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="tab-content">
                      <div
                        id="identity-policy-general"
                        class="tab-pane fade"
                        :class="[activeTab === 'general' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label class="required">Name</label>
                              <input
                                type="text"
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.name.$error,
                                }"
                                v-model="model.name"
                              />
                              <div v-if="isSubmitted && $v.model.name.$error">
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.required"
                                  >Name is required</small
                                >
                                <small
                                  class="form-text sts-danger"
                                  v-if="!$v.model.name.maxLength"
                                  >Name must be less than
                                  {{ $v.model.name.$params.maxLength.max }}
                                  characters</small
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <label>Desription</label>
                              <textarea
                                class="form-control"
                                :class="{
                                  'field-error':
                                    isSubmitted && $v.model.description.$error,
                                }"
                                rows="4"
                                v-model="model.description"
                              ></textarea>
                              <div
                                class="text-right word-count"
                                v-if="model.description"
                              >
                                {{ model.description.length }} &#47;
                                {{ $v.model.description.$params.maxLength.max }}
                                characters
                              </div>
                              <small
                                class="form-text sts-danger"
                                v-if="
                                  isSubmitted && !$v.model.description.maxLength
                                "
                                >Description must be less than
                                {{ $v.model.description.$params.maxLength.max }}
                                characters</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="identity-policy-service"
                        class="tab-pane fade"
                        :class="[activeTab === 'service' ? 'in active' : '']"
                      >
                        <div class="row">
                          <div class="col-sm-12">
                            <label class="cursor-pointer w-max-content">
                              <input
                                type="checkbox"
                                class="control-checkbox"
                                v-model="selectAllService"
                                @change="onSelectAll(model.services)"
                              />
                              <span
                                class="pl-5 font-weight-normal v-align-middle"
                              >
                                All
                              </span>
                            </label>
                            <div
                              v-for="service in model.services"
                              :key="service.name"
                            >
                              <label class="cursor-pointer w-max-content">
                                <input
                                  type="checkbox"
                                  class="control-checkbox"
                                  v-model="service.isSelected"
                                  @change="onChangePermission(service)"
                                />
                                <span
                                  class="pl-5 font-weight-normal v-align-middle"
                                >
                                  <span
                                    class="service-group"
                                    :class="{
                                      'service-group--master':
                                        service.group === 'Master',
                                      'service-group--security':
                                        service.group === 'IM',
                                      'service-group--deposit':
                                        service.group === 'Finance',
                                      'service-group--availability':
                                        service.group === 'Availability',
                                      'service-group--reservation':
                                        service.group === 'Reservation',
                                      'service-group--report':
                                        service.group === 'Report',
                                      'service-group--job':
                                        service.group === 'Job',
                                    }"
                                  >
                                    [{{ service.group }}]
                                  </span>
                                  {{ service.label }}
                                </span>
                                <div class="pl-25" v-if="service.isSelected">
                                  <label
                                    class="cursor-pointer"
                                    v-for="permission in service.permissions"
                                    :key="permission.name"
                                  >
                                    <input
                                      type="checkbox"
                                      class="control-checkbox"
                                      v-model="permission.isSelected"
                                    />
                                    <span
                                      class="pl-5 font-weight-normal v-align-middle"
                                    >
                                      {{ humanize(permission.name) }}
                                    </span>
                                  </label>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        {{ isUpdate ? "Save Changes" : "Save" }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import identityPolicyService from "@/services/master/identity/identityPolicyService.js";
import identityPolicySvcService from "@/services/master/identity/identityPolicySvcService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    permissionCount: function () {
      return this.allPermissions
        ? this.predefinedServices.flatMap((x) => x.permissions).length
        : 0;
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      activeTab: "general",
      allPermissions: [],
      selectAllService: false,
      predefinedServices: [],
      isUpdate: false,
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        name: { required, maxLength: maxLength(100) },
        description: { maxLength: maxLength(500) },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getAll();
      this.getPredefinedServices();
    }
  },
  updated() {
    this.$helper.collapseMenu("security");
    this.$helper.setNavigationClass("identity-policy-link");
  },
  mounted() {
    $(this.$refs.policymodal).on("hidden.bs.modal", this.closeModal);
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetModel() {
      this.model = {};
      this.selectAllService = false;
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.policymodal).modal({ backdrop: "static", keyboard: false });
    },
    closeModal() {
      this.resetModel();
      this.resetValidations();
      $(this.$refs.policymodal).modal("hide");
    },
    onChangePermission(service) {
      if (service.isSelected) {
        for (let index = 0; index < service.permissions.length; index++) {
          service.permissions[index].isSelected = true;
        }
      }
    },
    createItem() {
      this.resetModel();
      this.openModal({ services: [] });
      this.isUpdate = false;
      this.activeTab = "general";
      for (let i = 0; i < this.predefinedServices.length; i++) {
        const service = this.predefinedServices[i];
        this.model.services.push({
          isSelected: false,
          label: service.label,
          group: service.group,
          name: service.name,
          permissions: [],
        });
        for (let j = 0; j < service.permissions.length; j++) {
          this.model.services[i].permissions.push({
            isSelected: false,
            name: service.permissions[j],
          });
        }
      }
    },
    updateItem(item) {
      this.openModal(item);
      this.isUpdate = true;
      this.activeTab = "general";
      this.model.services = [];

      for (let i = 0; i < this.predefinedServices.length; i++) {
        const selectedService = item.services.find(
          (x) => x.name === this.predefinedServices[i].name
        );
        this.model.services.push({
          isSelected: selectedService !== undefined && selectedService !== null,
          group: this.predefinedServices[i].group,
          label: this.predefinedServices[i].label,
          name: this.predefinedServices[i].name,
          permissions: [],
        });
        for (
          let j = 0;
          j < this.predefinedServices[i].permissions.length;
          j++
        ) {
          let selectedPermission = null;
          if (
            selectedService &&
            selectedService.permissions &&
            selectedService.permissions.length > 0
          ) {
            selectedPermission = selectedService.permissions.find(
              (x) => x === this.predefinedServices[i].permissions[j]
            );
          }
          this.model.services[i].permissions.push({
            isSelected:
              selectedPermission !== undefined &&
              selectedPermission !== null &&
              selectedPermission !== "",
            name: this.predefinedServices[i].permissions[j],
          });
        }
      }
      this.selectAllService =
        this.model.services.filter((x) => x.isSelected).length ===
        this.predefinedServices.length;
    },
    async getPredefinedServices() {
      const services = await identityPolicySvcService.getAllPredefined();

      if (services && services.length > 0) {
        this.predefinedServices = services.sort(
          (prev, next) =>
            prev.group.localeCompare(next.group) ||
            prev.label.localeCompare(next.label)
        );
      }
    },
    countUsedPermission(services) {
      return services.flatMap((x) => x.permissions).length;
    },
    async getAll() {
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await identityPolicyService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      const selectedServices = this.model.services.filter((x) => x.isSelected);
      if (selectedServices.length === 0) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.services = [];
        selectedServices.forEach((item, index) => {
          const selectedPermissions = item.permissions.filter(
            (x) => x.isSelected
          );
          if (selectedPermissions && selectedPermissions.length > 0) {
            let service = {
              name: item.name,
              permissions: [],
            };
            for (let i = 0; i < selectedPermissions.length; i++) {
              service.permissions.push(selectedPermissions[i].name);
            }
            this.model.services.push(service);
          }
        });
        if (this.isUpdate) {
          await identityPolicyService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await identityPolicyService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await identityPolicyService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await identityPolicyService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.$store.dispatch("user/removeProfile");
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    onSelectAll(services) {
      for (let i = 0; i < services.length; i++) {
        services[i].isSelected = this.selectAllService;
        for (let j = 0; j < services[i].permissions.length; j++) {
          services[i].permissions[j].isSelected = this.selectAllService;
        }
      }
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
  },
};
</script>

<style>
#identity-policy-service > .row {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 500px;
}

.service-group {
  font-weight: bold;
}

.service-group--master {
  color: #007bff;
}

.service-group--security {
  color: #28a745;
}

.service-group--deposit {
  color: #ffc107;
}

.service-group--availability {
  color: #343a40;
}

.service-group--reservation {
  color: #17a2b8;
}

.service-group--report {
  color: brown;
}

.service-group--job {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/security/identity/IdentityPolicy.vue